// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3M3le","box":"WorkspacesBox_box__240oE","node":"WorkspacesBox_node__1MgFW"};